import { v4 } from 'uuid';

/**
 * @typedef {object} PrintJob
 * @property {string} documentType - one of the DocumentType enum identifiers
 * @property {string[]} ids
 * @property {string} printUrl
 * @property {string} requestId - sent to connect
 * @property {object} [printer]
 * @property {string|number} [templateId]
 */

/**
 * @param {object} args
 * @param {string} args.documentTypeIdentifier - one of the DocumentType enum identifiers
 * @param {string} args.downloadUrl - the url connect will use to download the document
 * @param {string[]} args.ids - the ids of the relevant entities the documents are for e.g. fulfillmentPlanIds
 * @param {object} args.printer - the ss connect printer to use for the job
 * @param {string | number} [args.templateId] - the template id to use, e.g. the packing slip template id
 * @returns {PrintJob}
 */
export const printJobFactory = ({ documentTypeIdentifier, downloadUrl, ids, printer, templateId }) => {
  const printJob = {
    requestId: v4(),
    printer,
    documentType: documentTypeIdentifier,
    ids: ids || [],
    printUrl: downloadUrl,
    templateId,
  };
  return printJob;
};
